// extracted by mini-css-extract-plugin
export default {"headline":"Bn_MI6hMp4eeVzGiZbQV","title":"WaUzIhLiFum824_2DfQl"};